module.exports = __webpack_public_path__ + "img/xinxihuayubaomi.93c59c59.png";